import React from 'react';
import GameScoreInfo from './GameScoreInfo';
import './GameScoreInfo.css';

/**
 * GameCardContent component displays the content of a game card
 * 
 * @param {Object} props - Component props
 * @param {string} props.username - Username of the player
 * @param {Object} props.userEntry - User entry in the leaderboard
 * @param {boolean} props.isRanked - Whether the player is ranked in this game
 * @param {Array} props.leaderboard - Array of player objects for the game
 */
function GameCardContent({ username, userEntry, isRanked, leaderboard = [] }) {
  if (isRanked && userEntry) {
    return (
      <>
        <p><strong>Points:</strong> {userEntry.points}</p>
        
        {/* Display additional score information */}
        <GameScoreInfo 
          leaderboard={leaderboard}
          userEntry={userEntry}
          isRanked={isRanked}
        />
      </>
    );
  } else {
    return (
      <>
        <div className="not-ranked">
          {!username ? 'Search for a username to see your ranking' : 'Not ranked in this game'}
        </div>
        
        {/* Display additional score information even when not ranked */}
        <GameScoreInfo 
          leaderboard={leaderboard}
          userEntry={null}
          isRanked={false}
        />
      </>
    );
  }
}

export default GameCardContent;